import introductionFinancialMathematicsImg from 'assets/images/booksOverview/introductionFinancialMathematics.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const introductionFinancialMathematics = {
  book: {
    id: 'finanzmathematik',
    format: FLIP_BOOKS,
    title: 'Introduction to Financial Mathematics for Beginners',
    subtitle: 'The mathematical foundations of investing',
    videos: 'Erwin W. Heri, Stefan Holzer, Nicolas Plain',
    layoutAndProduction: 'Erwin W. Heri',
    scope: { pages: 60, videos: 31 },
    price: [0, 82],
    introductions: [
      'Formulas are not a secret science',
      'Introduction to Financial Mathematics for Beginners starts with the compound interest formula',
      'No advanced mathematics, no prior knowledge of statistics',
      'One example is enough to show how much a formula can say',
    ],
    image: introductionFinancialMathematicsImg,
    overviewImg: introductionFinancialMathematicsImg,
  },
  bookIds: [53, 54],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([0, 82], [54, 53]),
};

export default introductionFinancialMathematics;
